// extracted by mini-css-extract-plugin
export var root = "B_vf";
export var wrapper = "B_vg";
export var image = "B_vh d_w d_y d_W";
export var imageWithHeight = "B_vj";
export var crop = "B_vk";
export var round = "B_vl";
export var fixedHeight = "B_vm";